<template>
  <CDropdown
    inNav
    class="c-header-nav-items theheaderaccount"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink ref="userdropdown">
        <div class="c-avatar dropdown-toggle">
          <CIcon name="cil-user"/>
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" color="light" class="text-center">
      <strong>Mitarbeiter</strong>
    </CDropdownHeader>

    <CDropdownItem disabled>
      <span class="text-center" style="width: 100%;">
        {{ name }}
      </span>
    </CDropdownItem>

    <CDropdownItem disabled style="padding-top: 0;">
      <span class="text-center" style="width: 100%; font-size: 0.6rem;">
        Letzter Login am
        <br>
        {{last_login|moment('DD.MM.YYYY')}}
        um
        {{last_login|moment('HH:mm:ss')}} Uhr
      </span>
    </CDropdownItem>

    <CDropdownItem disabled class="theheaderaccount__roles">
      <div class="theheaderaccount__roles-title">Rollen im Frontend</div>
      <div class="theheaderaccount__roles-list">
        {{ displayRoles }}
      </div>
      <div class="theheaderaccount__roles-checks">
        <div>Super Admin: {{ roleCheckLabel(['ROLE_SUPER_ADMIN']) }}</div>
        <div>Admin: {{ roleCheckLabel(['ROLE_ADMIN']) }}</div>
        <div>Kalender: {{ roleCheckLabel(['ROLE_KALENDER']) }}</div>
        <div>Team: {{ roleCheckLabel(['ROLE_TEAM']) }}</div>
        <div>Report: {{ roleCheckLabel(['ROLE_REPORT']) }}</div>
        <div>Kalenderbereich: {{ roleCheckLabel(['ROLE_KALENDER', 'ROLE_TEAM', 'ROLE_REPORT']) }}</div>
      </div>
    </CDropdownItem>

    <CDropdownDivider/>

    <CDropdownItem to="/profile/password">
      <CIcon name="cil-https" /> Mein Passwort Ändern
    </CDropdownItem>

    <CDropdownItem to="/security/logout" class="text-center" style="display: block;">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      name: ''
    }
  },
  computed: {
    user: function () {
      return this.$store.getters['security/user']
    },
    last_login () {
      return (this.user ? this.user.last_login : '')
    },
    displayRoles () {
      if (!this.user || !Array.isArray(this.user.roles) || this.user.roles.length === 0) {
        return '-'
      }

      return this.user.roles.join(', ')
    }
  },
  mounted () {
    this.getName()
  },
  methods: {
    async getName () {
      const mitarbeiterloaded = await this.loadMitarbeiter()
      const curUser = mitarbeiterloaded.data.filter(mitarbeiter => {
        return mitarbeiter.mitarbeiterid === this.user.userid
      })

      this.name = curUser.length > 0 ? curUser[0].name : ''
    },
    async loadMitarbeiter () {
      return Vue.axios.get('/mitarbeiter/get')
    },
    roleCheckLabel (roles) {
      return this.$roleBasedSecurity.userHasRole(roles) ? 'ja' : 'nein'
    }
  }
}
</script>

<style lang="scss">
  li.theheaderaccount {
    .c-icon {
      margin-right: 0.3rem;
    }
    a.disabled {
      color: rgba(0, 0, 21, 0.5) !important;
    }
  }

  .theheaderaccount__roles {
    align-items: stretch;
    display: block;
    white-space: normal;
  }

  .theheaderaccount__roles-title {
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    margin-bottom: 0.2rem;
    text-transform: uppercase;
  }

  .theheaderaccount__roles-list {
    font-family: monospace;
    font-size: 0.68rem;
    line-height: 1.4;
    margin-bottom: 0.35rem;
    overflow-wrap: anywhere;
  }

  .theheaderaccount__roles-checks {
    font-size: 0.68rem;
    line-height: 1.4;
  }
</style>
